import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ea902c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","align-items":"center","justify-content":"center","padding":"20px","position":"relative"} }
const _hoisted_2 = { style: {"position":"absolute","left":"20px","top":"20px","z-index":"1"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","justify-content":"space-around","align-items":"center","height":"28px"} }, [
  /*#__PURE__*/_createElementVNode("div", null, "请使用支付宝扫码支付")
], -1))
const _hoisted_4 = { style: {"font-size":"30px"} }
const _hoisted_5 = { style: {"padding":"10px"} }

import ScBtn from '@/components/common/widget/ScBtn.vue';
import { inject, onMounted, ref } from 'vue';
import { toCanvas } from 'qrcode';
import zfbIcon from '@/assets/images/zfb_icon.svg';
import { message, Modal } from 'ant-design-vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import { request } from '@/util/request';


export default /*#__PURE__*/_defineComponent({
  __name: 'Payment',
  props: {
    qrUrl: {},
    order: {}
  },
  setup(__props: any) {

const props = __props;

const windowTool = inject<WindowTool | false>(WindowTool, false);

async function check(showMsg: boolean) {
  const res = await request('/management/order/checkPayment', {
    id: props.order.id,
  });
  if (res.status === 'wait') {
    if (showMsg) {
      message.warn('未检测到支付成功');
    }
    return;
  }
  windowTool && windowTool.close();
  Modal.info({
    title: '恭喜完成支付',
  });
}

const qrRef = ref();

// const intervalHandler = setInterval(() => check(false), 5000);
//
// onUnmounted(() => clearInterval(intervalHandler));

onMounted(() => {
  toCanvas(qrRef.value, props.qrUrl, {
    width: 280,
    margin: 0,
  });
});

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_image, {
        src: _unref(zfbIcon),
        preview: false
      }, null, 8, ["src"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, "¥" + _toDisplayString(_ctx.order.price), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("canvas", {
        ref_key: "qrRef",
        ref: qrRef
      }, null, 512)
    ]),
    _createElementVNode("div", null, [
      _createVNode(ScBtn, {
        text: "已完成支付",
        type: "primary",
        handler: () => check(true),
        style: {"margin-left":"16px"}
      }, null, 8, ["handler"])
    ])
  ]))
}
}

})